import { isValidPhoneNumber } from 'react-phone-number-input'
import { MENTOR_ONBOARDING_TYPES } from 'src/consumer/constants'
import { getMPDataWithParams } from 'src/mentor/services'

export function decodeEncodedOffset(encodedOffset) {
  // Use decodeURIComponent to decode the URL-encoded offset
  const decodedOffset = decodeURIComponent(encodedOffset)

  return decodedOffset
}
export function convertToEncodedOffset(encodedOffset) {
  // Use decodeURIComponent to decode the URL-encoded offset
  const decodedOffset = encodeURIComponent(encodedOffset)

  return decodedOffset
}

export function profileSaveFunction(formState) {
  return {
    ...formState,
    slug: formState?.slug || formState?.tempSlug,
    shortDesc: formState?.shortDesc || formState?.tempShortDesc,
    translations: {
      ...formState.translations,
      en: { ...formState?.translations?.en, firstName: formState?.firstName || '' },
    },
  }
}

export function mentorProfileSaveFunction(formState) {
  return {
    ...formState,
    personalize: {
      ...formState?.personalize,
      techniquesSpecializedIn: formState?.personalize?.techniquesSpecializedIn?.map(
        (technique) => technique?.id,
      ),
    },
  }
}

export function getPhoneValidity(profileData, phone) {
  const formattedPhone = phone?.startsWith('+') ? phone : `+${phone}`
  let phoneValid = isValidPhoneNumber(formattedPhone || '')
}

export async function getSingleTechnique(techniqueId) {
  const response = await getMPDataWithParams(`/api/secure/technique/${techniqueId}`)
  if (response.status === 200) {
    return response
  }
}

export function getStringsForMentorWelcomePopup({ onboardingType }) {
  let pageStrings = {
    page1: {
      title: 'Welcome to AUMHUM for mentors',
      subtitle:
        'Welcome aboard! This is the place where you will be putting up the content for the community.',
      content: "Let's get you setup!",
      buttonText: 'Proceed',
    },
    page2: {
      title: 'Welcome to AUMHUM for mentors',
      subtitle: 'You can do the following as a mentor.',
      buttonText: 'Proceed',
    },
  }

  switch (onboardingType) {
    case MENTOR_ONBOARDING_TYPES.DOCTOR:
      pageStrings.page1.title = 'Welcome to AUMHUM for doctors'
      pageStrings.page1.subtitle =
        'Welcome aboard! This is the place where you will be working with patients and providing them with the best care possible.'
      pageStrings.page1.content = "Let's get you setup!"
      pageStrings.page1.buttonText = 'Proceed'
      pageStrings.page2.title = 'Welcome to AUMHUM for doctors'
      pageStrings.page2.subtitle = null
      pageStrings.page2.buttonText = 'Proceed'
      break
    case MENTOR_ONBOARDING_TYPES.THERAPIST:
      pageStrings.page1.title = 'Welcome to AUMHUM for therapists'
      pageStrings.page1.subtitle =
        'Welcome aboard! This is the place where you will be working with patients and providing them with the best care possible.'
      pageStrings.page1.content = "Let's get you setup!"
      pageStrings.page1.buttonText = 'Proceed'
      pageStrings.page2.title = 'Welcome to AUMHUM for therapists'
      pageStrings.page2.subtitle = null
      pageStrings.page2.buttonText = 'Proceed'
      break
    default:
      break
  }

  return pageStrings
}

export async function getSuggestedSlugForCreator({ formState }) {
  if (!formState?.firstName) {
    return ''
  }
  const response = await getMPDataWithParams('/api/secure/creator/slug/suggest', {
    firstName: formState?.firstName,
  })
  if (response.status === 200) {
    return response.data
  }
  return ''
}

export function getCustomShortBioForMentor({ formState, metaCategories }) {
  let string = ''
  const specializiedCategory = formState?.specializedCategories
  const specializiedCategoryTitles = specializiedCategory?.map((categoryId) => {
    const category = metaCategories?.find((metaCategory) => metaCategory.id === categoryId)
    return category?.singleTitle || category?.title || category?.id
  })
  if (formState?.firstName) {
    string += `${formState?.firstName} is `
  }

  console.log({ formCats: formState?.categories })

  const mentorCategories = (
    formState?.categories?.filter((category) => category !== 'doctor') || []
  )?.map((category) => {
    const categoryData = metaCategories?.find((metaCategory) => metaCategory.id === category)
    return categoryData?.singleTitle || categoryData?.title || category
  })

  if (mentorCategories?.length > 0 && !formState?.categories?.includes('doctor')) {
    const categories = mentorCategories
      .map((category, index) => {
        if (index === mentorCategories.length - 1 && index !== 0) {
          return `and ${category}`
        }
        return category
      })
      .join(', ')
      .replace(', and', ' and') // Replace ", and" with " and" for proper formatting

    const firstCategory = mentorCategories?.[0]
    const article = /^[aeiouAEIOU]/.test(firstCategory) ? 'an' : 'a'

    string += `${article} ${categories}`
  }

  if (!!specializiedCategoryTitles && specializiedCategoryTitles?.length > 0) {
    const specializations = specializiedCategoryTitles
      .map((category, index) => {
        if (index === formState.specializedCategories.length - 1 && index !== 0) {
          return `and ${category}`
        }
        return category
      })
      .join(', ')
      .replace(', and', ' and') // Replace ", and" with " and" for proper formatting

    console.log(specializations)

    const firstSpecialization = specializiedCategoryTitles?.[0]
    const article = /^[aeiouAEIOU]/.test(firstSpecialization) ? 'an' : 'a'

    string += `${article} ${specializations}`
  }

  if (formState?.location?.city || formState?.location?.country) {
    string += ` based in`
  }

  if (formState?.location?.city) {
    string += ` ${formState?.location?.city},`
  }

  if (formState?.location?.country) {
    string += ` ${formState?.location?.country}`
  }
  string += '.'
  return string
}

export function getMentorProfileAllPagesWithTitlesChanges({ onboardingType }) {
  let pageTitles = {
    basic: { pageValue: 'basic', label: 'Basic Details' },
    mentoring: { pageValue: 'mentoring', label: 'Mentoring Details & Settings' },
    images: { pageValue: 'images', label: 'Your Images' },
    // onboarding: { pageValue: 'onboarding', label: 'Onboarding Section' },
    // introMessage: { pageValue: 'intro-message', label: 'Intro Message' },
    agreements: { pageValue: 'agreements', label: 'Agreements' },
  }

  switch (onboardingType) {
    case MENTOR_ONBOARDING_TYPES.DOCTOR:
      pageTitles.basic.label = 'Basic Details'
      pageTitles.mentoring.label = 'Doctor Details & Settings'
      pageTitles.images.label = 'Your Images'
      // pageTitles.onboarding.label = 'Onboarding Section'
      // pageTitles.introMessage.label = 'Intro Message'
      pageTitles.agreements.label = 'Agreements'
      break
    case MENTOR_ONBOARDING_TYPES.THERAPIST:
      pageTitles.basic.label = 'Basic Details'
      pageTitles.mentoring.label = 'Therapist Details & Settings'
      pageTitles.images.label = 'Your Images'
      // pageTitles.onboarding.label = 'Onboarding Section'
      // pageTitles.introMessage.label = 'Intro Message'
      pageTitles.agreements.label = 'Agreements'
      break
    default:
      break
  }

  return pageTitles
}
